
function RefreshTokenWindow({isOpenWindow, onCloseWindow, apiAppId}) {

    return (<></>);
}

export default RefreshTokenWindow;